exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.main-wrapper[data-v-10e72d3e]{margin:16px 0\n}\n", "", {"version":3,"sources":["/Users/danielngo/Desktop/fastpro/frontend/src/components/Resource.vue"],"names":[],"mappings":";AAAA,+BAAc,aAAa;CAAE","file":"Resource.vue","sourcesContent":[".main-wrapper{margin:16px 0}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-10e72d3e","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Resource.vue
// module id = aArI
// module chunks = 4